import React from 'react';
import { Icon } from '@iconify/react';

const VARIANTS = {
  incomplete: {
    icon: 'mdi:file-document-edit-outline',
    label: 'Brief incomplet',
    title: 'Brief créatif à compléter',
  },
  complete: {
    icon: 'mdi:file-document-check-outline',
    label: 'Brief complet',
    title: 'Brief créatif renseigné — cliquer pour consulter',
  },
};

const KkpBriefStatusBadge = ({ variant = 'incomplete', onClick, className = '' }) => {
  const config = VARIANTS[variant] ?? VARIANTS.incomplete;

  return (
    <button
      type="button"
      className={`kkp-brief-status-badge kkp-brief-status-badge--${variant} ${className}`.trim()}
      onClick={onClick}
      title={config.title}
    >
      <Icon icon={config.icon} width={14} />
      {config.label}
    </button>
  );
};

export default KkpBriefStatusBadge;
